/* ==========================================================================
   AEROBRIZ — Global JS (native, no jQuery)
   ========================================================================== */

(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  /* ---------- Sticky header ---------- */
  function initStickyHeader() {
    var header = document.querySelector('[data-sticky-header]');
    if (!header) return;

    var lastScroll = 0;
    var threshold = 80;

    function onScroll() {
      var current = window.pageYOffset || document.documentElement.scrollTop;
      if (current > threshold) {
        header.classList.add('is-stuck');
      } else {
        header.classList.remove('is-stuck');
      }
      lastScroll = current;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mobile menu ---------- */
  function initMobileMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var drawer = document.querySelector('[data-menu-drawer]');
    if (!toggle || !drawer) return;

    function open() {
      drawer.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) {
        close();
      } else {
        open();
      }
    });

    var closeBtn = drawer.querySelector('[data-menu-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);

    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* ---------- Brands carousel (seamless marquee) ---------- */
  function initCarousels() {
    var carousels = document.querySelectorAll('[data-carousel]');
    carousels.forEach(function (carousel) {
      var track = carousel.querySelector('[data-carousel-track]');
      var prev = carousel.querySelector('[data-carousel-prev]');
      var next = carousel.querySelector('[data-carousel-next]');
      if (!track || carousel.hasAttribute('data-carousel-init')) return;
      carousel.setAttribute('data-carousel-init', '1');

      var paused = false;
      var pos = 0;
      var SPEED = 0.4;
      var resume;
      var baseWidth = track.scrollWidth;

      // Clone tiles once for a seamless infinite loop (only if they overflow)
      if (baseWidth - track.clientWidth > 4) {
        Array.prototype.slice.call(track.children).forEach(function (el) {
          track.appendChild(el.cloneNode(true));
        });
      }

      function wrap() {
        if (baseWidth > 0) {
          if (pos >= baseWidth) pos -= baseWidth;
          if (pos < 0) pos += baseWidth;
        }
      }

      // Pause on hover so tiles stay clickable
      carousel.addEventListener('mouseenter', function () { paused = true; clearTimeout(resume); });
      carousel.addEventListener('mouseleave', function () { pos = track.scrollLeft; wrap(); paused = false; });

      // Manual scroll/drag: follow the cursor, keep position (never reset)
      track.addEventListener('scroll', function () { if (paused) { pos = track.scrollLeft; wrap(); } }, { passive: true });
      ['wheel', 'touchstart', 'pointerdown'].forEach(function (ev) {
        track.addEventListener(ev, function () { paused = true; clearTimeout(resume); }, { passive: true });
      });
      ['touchend', 'pointerup', 'mouseup'].forEach(function (ev) {
        track.addEventListener(ev, function () {
          pos = track.scrollLeft; wrap();
          clearTimeout(resume);
          resume = setTimeout(function () { if (!carousel.matches(':hover')) paused = false; }, 1500);
        }, { passive: true });
      });

      // Optional nudge buttons
      function nudge(dir) {
        var firstCard = track.querySelector('[data-carousel-item]');
        var step = firstCard ? firstCard.offsetWidth + 24 : 200;
        paused = true; clearTimeout(resume);
        track.scrollBy({ left: dir * step, behavior: 'smooth' });
        resume = setTimeout(function () { pos = track.scrollLeft; wrap(); if (!carousel.matches(':hover')) paused = false; }, 900);
      }
      if (prev) prev.addEventListener('click', function () { nudge(-1); });
      if (next) next.addEventListener('click', function () { nudge(1); });

      function loop() {
        if (!paused && baseWidth - track.clientWidth > 4) {
          pos += SPEED; wrap();
          track.scrollLeft = pos;
        }
        requestAnimationFrame(loop);
      }
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        requestAnimationFrame(loop);
      }
    });
  }

  /* ---------- Init ---------- */
  function init() {
    initStickyHeader();
    initMobileMenu();
    initCarousels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
